import React from 'react';
import R from 'ramda';
import CardsStackedVerticalQuarter
from '../components/stacked/quarter-width/CardsStackedVerticalQuarter/CardsStackedVerticalQuarter';
import CardsStackedVerticalOneThird
from '../components/stacked/one-third-width/CardsStackedVerticalOneThird/CardsStackedVerticalOneThird';
import CardsStackedVerticalHalf
from '../components/stacked/half-width/CardsStackedVerticalHalf/CardsStackedVerticalHalf';
import CardsStackedVerticalFull
from '../components/stacked/full-width/CardsStackedVerticalFull/CardsStackedVerticalFull';

const defaultCardsPerPageMap = {
  xsmall: 2,
  small: 2,
  medium: 3,
  large: 4,
  xlarge: 4,
};

export const getNoOfCardsPerPage = ({ currentBreakpoint, cardsPerPageMap = defaultCardsPerPageMap }) => (
  R.propOr(2, currentBreakpoint)(cardsPerPageMap)
);

export const mapCardsToPages = ({ currentBreakpoint, cardsData = [], cardsPerPageMap }) => {
  const noOfCardsPerPage = getNoOfCardsPerPage({ currentBreakpoint, cardsPerPageMap });
  const noOfPages = Math.ceil(cardsData.length / noOfCardsPerPage);

  return [...Array(noOfPages)].map((item, index) => (
    cardsData.slice(index * noOfCardsPerPage, (index * noOfCardsPerPage) + noOfCardsPerPage)
  ));
};

export const getPages = ({
  currentBreakpoint,
  cardsData,
  getCardsProps,
  cardsPerPageMap,
}) => {
  const noOfCardsPerPage = getNoOfCardsPerPage({ currentBreakpoint, cardsPerPageMap });

  return (
    mapCardsToPages({ currentBreakpoint, cardsData, cardsPerPageMap }).map(page => (
      (noOfCardsPerPage === 4) ? (
        <CardsStackedVerticalQuarter {...getCardsProps(page)} />
      ) : (noOfCardsPerPage === 3) ? (
        <CardsStackedVerticalOneThird {...getCardsProps(page)} />
      ) : (noOfCardsPerPage === 2) ? (
        <CardsStackedVerticalHalf {...getCardsProps(page)} isSmallWidthHalf />
      ) : (
        <CardsStackedVerticalFull {...getCardsProps(page)} />
      )
    ))
  );
};
